<template>
    <v-dialog v-model="editing" width="500">
        
        <template></template>
            <v-form ref="form">
                <v-card class="p-3">
                    <v-container>
                    <h6 class="text-center py-4 h6">{{title}}</h6>
           
                    <v-text-field 
                        label="First Name"
                        v-model="first_name"
                        :rules="[rules.required]"
                    ></v-text-field>
                    <v-text-field 
                        label="Last Name"
                        v-model="last_name"
                        :rules="[rules.required]"
                    ></v-text-field>
                    <v-text-field 
                        label="Email"
                        v-model="email"
                        :rules="[rules.required, rules.email]"
                    ></v-text-field>
                    <v-checkbox
                        v-for="role in roles"
                        :key="role.id"
                        v-model="selectedRoles"
                        :rules="[noRolesSelected]"
                        :label="role.name"
                        :value="role.id"
                    ></v-checkbox>
                    <v-divider></v-divider>
        
                    <v-spacer></v-spacer>
                    <v-row align="end">
                        <v-col cols="6"></v-col>
                        <v-col cols="6">
                        <v-btn color="error" text @click="$emit('dialog-clicked')">
                            Cancel
                        </v-btn>
                        <v-btn color="success" text
                        @click="submitForm">
                            Save
                        </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
            </v-form>
    </v-dialog>
</template>

<script>

import rules from '../../helpers/forms'
import { mapState, mapActions, mapMutations } from 'vuex'


export default {
    name: 'UserFormModal',
    data(){
        return {
            mergeDialog: false,
            confirmMergeDialog: false,
            tag_to_merge_into: 1,
            confirmDeleteDialog: false,
            showPassword: false,
            email: '',
            first_name: '',
            last_name: '',
            password: '',
            selectedRoles: [],
            rules: rules,
        }
    },
    props: {
        editing:{
            type: Boolean,
            default:false
        },
        title: {
            type: String,
            default: ''
        },
        user: {
            type: Object,
            required: false
        }
    },
    mounted(){
        if(this.$props.user){
            this.email = this.$props.user.email
            this.first_name = this.$props.user.first_name
            this.last_name = this.$props.user.last_name
            this.selectedRoles = this.$props.user.roles.map(role => {
                return this.roles.find(r => r.name === role)
            })
           this.selectedRoles = this.selectedRoles.map(r => r.id)
        
        } else {
                this.email = ''
            this.first_name = ''
            this.last_name = ''

        }
    },
    computed: {
      ...mapState({
            roles: state => state.users.roles,
      }),
      noRolesSelected(){
          return this.selectedRoles.length !== 0 || 'Must select role to create user'
      },
      
    },
    methods: {
    ...mapActions(['postRegister', 'editUser']),
      ...mapMutations(['setMessage']),
        submitForm(){
            let payload = {}
            let message = {
                  text: 'User Added',
                  type: 'success',
                  alert: true
            }
            if(!this.user){
                payload = {
                roles: this.selectedRoles,
                email: this.email,
                first_name: this.first_name,
                last_name: this.last_name,
                }
            

                this.postRegister(payload)
                this.setMessage(message)
            } else {
                payload = {
                    id: this.$props.user.id,
                    roles: this.selectedRoles,
                    email: this.email,
                    first_name: this.first_name,
                    last_name: this.last_name,

                }
                this.editUser(payload)
                message.text = 'User Updated'
                this.setMessage(message)
            }
         
            this.$emit('dialog-clicked')
        },
        handleConfirm(val){
            this.confirmMergeDialog = true
            this.tag_to_merge_into = val
        }
    }
    
}
</script>